import{a}from"./chunk.2AIXLGYE.js";import{a as l}from"./chunk.VDLOD2KK.js";import{a as i}from"./chunk.65JZXZ5X.js";import{c as e}from"./chunk.NWIV65VP.js";import{property as s}from"lit/decorators.js";import{html as n}from"lit/static-html.js";import{css as o}from"lit";var r=o`
  ${a}

  h1 {
    font-size: var(--he-font-size-3x-large);
    line-height: var(--he-line-height-3x-large);
    color: var(--he-color-neutral-900);
    margin: 0;
    padding: 0;
  }

  .title {
    font-weight: var(--he-font-weight-semibold);
  }

  .active-title,
  .divider {
    font-weight: var(--he-font-weight-normal);
  }

  .title,
  .active-title {
    /* this allows spans to change visual order in rtl */
    display: inline-block;
  }

  [hidden] {
    display: none;
  }

  ::slotted(.he-quick-nav) {
    margin: 0 calc(var(--he-spacing-x-small) * -1);
    --button-font-size: var(--he-font-size-3x-large);
    --button-line-height: var(--he-line-height-3x-large);
  }
`;var t=class extends i{constructor(){super(...arguments);this.hasSlotController=new l(this,"[default]","active-title")}render(){return n`
      <h1 part="base">
        <span class="title" part="workspace-title">
          <slot></slot>
          <span class="divider" part="divider" ?hidden=${!this.hasSlotController.test("active-title")}>|</span>
        </span>
        <span class="active-title" part="active-title" ?hidden=${!this.hasSlotController.test("active-title")}>
          <slot name="active-title"></slot>
        </span>
      </h1>
    `}};t.styles=r,t.baseName="page-title",t.reactEvents={},e([s({attribute:"active-title"})],t.prototype,"activeTitle",2);var x=t;export{t as a,x as b};
